export default __webpack_public_path__ + "static/media/MOCKUP - hiperfoco.e0cdd0a9.png";